<template>
  <a-table :pagination='false' :loading='listLoading' :rowKey='keyRow'  :columns='columns' :data-source='data' bordered>
    <template #grantTitle>
      <span>
        门店发放数量
        <a-tooltip placement="right" :get-popup-container="getPopupContainer" :auto-adjust-overflow="false">
          <template #title>
            消费者在门店对应云店中领取的优惠券数量
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </span>
    </template>
    <template #useTitle>
      <span>
        使用数量
        <a-tooltip placement="right" :get-popup-container="getPopupContainer" :auto-adjust-overflow="false">
          <template #title>
            消费者在门店对应云店中使用的优惠券数量，优惠券来源包含且不限于扫码活动、会员权益和直接发放等
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </span>
    </template>
  </a-table>
</template>
<script>
import { ref,reactive, toRefs,onMounted } from "vue";
export default {
  props:{
    listLoading:Boolean,
    data:Array,
    keyRow:String,
    active:Number || String
  },
  setup(props) {
    const state = reactive({
      columns:[],
      columns1: [
        {
          title: "日期",
          dataIndex: "date_time",
          key: "date_time",
        },
        {
          title: "发放数量",
          dataIndex: "receive_num",
          key: "receive_num",
        },
        {
          title: "使用数量",
          dataIndex: "use_num",
          key: "use_num",
        }
      ],
      columns2: [
        {
          title: "发放渠道",
          dataIndex: "source_type_text",
          key: "source_type_text",
        },
        {
          title: "发放数量",
          dataIndex: "receive_num",
          key: "receive_num",
        },
        {
          title: "使用数量",
          dataIndex: "use_num",
          key: "use_num",
        },
        {
          title: "使用率",
          dataIndex: "rate",
          key: "rate",
          customRender: ({ record }) => {
            return record.rate+'%';
          },
        }
      ],
      columns3: [
        {
          title: "排名",
          dataIndex: "rank",
          key: "rank",
        },
        {
          title: "门店",
          dataIndex: "store_name",
          key: "store_name",
        },
        {
          dataIndex: "receive_num",
          key: "receive_num",
          slots: { title: 'grantTitle' },
        },
        {
          dataIndex: "use_num",
          key: "use_num",
          slots: { title: 'useTitle' },
        },
        {
          title: "使用率",
          dataIndex: "rate",
          key: "rate",
          customRender: ({ record }) => {
            return record.rate+'%';
          },
        }
      ]
    });
    onMounted(() => {
      if(props.active == 1){
        state.columns = state.columns1
      }else if(props.active == 2){
        state.columns = state.columns2
      }else{
        state.columns = state.columns3
      }
    });
    return {
      ...toRefs(state)
    };
  }
  
}
</script>
